import React from 'react';
var WindowConfigContext = React.createContext(null);
export var WindowConfigProvider = WindowConfigContext.Provider;
export var WindowConfigConsumer = WindowConfigContext.Consumer;
export default WindowConfigContext;
//# sourceMappingURL=window-config-context.js.map